<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
        >
          <el-input
            v-model="searchForm.shop_name"
            placeholder="店名"
            width="50"
          />
        </el-form-item>

        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.state"
                  placeholder="状态"
                  width="50"
          >
            <el-option
                    v-for="item in typeOptions"
                    :key="item.velue"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-button
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="add"
    >
      新增
    </el-button>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="门店名称"
      >
        <template slot-scope="scope">
          {{scope.row.shop_name}}
        </template>
      </el-table-column>
      <el-table-column
        label="门店编号"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.shop_no}}
        </template>
      </el-table-column>
      <el-table-column
              label="地址"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.compaddress}}
        </template>
      </el-table-column>
      <el-table-column
        label="状态"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.state=='0'">
            正常
          </div>
          <div v-else-if="scope.row.state=='1'">
            禁用
          </div>
        </template>
      </el-table-column>

      <el-table-column
              label="创建时间"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.create_dates}}
        </template>
      </el-table-column>
      <el-table-column
              label="当前行业"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.industry}}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="450"
      >
        <template slot-scope="scope">
          <el-button type="primary" plain  size="mini"    @click="openEditForm(scope.row)">编辑</el-button>
          <el-button type="primary" plain size="mini"    @click="openEditForm2(scope.row)">详情</el-button>
          <el-button type="primary" plain  size="mini"   @click="openViewForm(scope.row)">设置行业</el-button>
          <el-button type="primary" plain  size="mini"   @click="openCloudspeakerForm(scope.row)">云喇叭管理</el-button>
          <el-button type="primary" plain  size="mini"   @click="openPrintingForm(scope.row)">云打印管理</el-button>
        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <edit-form
      :agent="oneclass"
      v-model="editFormVisible"
      :accuseVisible="accuseVisible"
      @submit="getTableData"
    />

    <view-form
            :agent="oneclass"
            v-model="viewFormVisible"
            @submit="getTableData"
    />
      <cloudspeaker-form
              :agent="oneclass"
              v-model="cloudspeakerFormVisible"
              @submit="getTableData"
      />
    <printing-form
            :agent="oneclass"
            v-model="printingFormVisible"
            @submit="getTableData"
    />

  </d2-container>
</template>
<script>
    import * as agentService from "@/api/sys/agent";
    import util from '@/libs/util.js'
import editForm from "./editForm";
    import viewForm from "./viewForm"
    import cloudspeakerForm from "./cloudspeakerForm"
    import printingForm from "./printingForm"
export default {
  name: "PosterPage",
  components: { editForm,viewForm,cloudspeakerForm,printingForm },
  data() {
    return {
      searchForm: {
          advTitle: ""
      },
      loading: false,
      tableData: [],
        accuseVisible:true,
      multipleSelection: [],
        typeOptions: [
            {
                value: "0",
                label: "正常"
            },
            {
                value: "1",
                label: "禁用"
            }
        ],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: "",
        order: ""
      },
        oneclass: {},
      editFormVisible: false,
        viewFormVisible: false,
        printingFormVisible:false,
        cloudspeakerFormVisible: false
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
          agentid:util.cookies.get('agentid'),
        descending: this.sort.order === "descending",
        filter: this.searchForm
      };
        agentService.getAgentStorePagedList(query).then(data => {
        this.tableData = data.rows;
        this.page.total = data.totalCount;
      });
    },
      getImgUrl(row){
          return "https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/"+row.imgpath;
      },
    handleSearchFormSubmit() {
      this.getTableData();
    },
    handleSearchFormReset() {
      this.$refs.searchForm.resetFields();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSortChange(val) {
      this.sort.prop = val.prop;
      this.sort.order = val.order;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getTableData();
    },
      openViewForm(oneclass) {
          this.oneclass = oneclass;
          this.editFormVisible = false;
          this.viewFormVisible = true;
      },
    openEditForm(oneclass) {
      this.oneclass = oneclass;
      this.editFormVisible = true;
        this.viewFormVisible = false;
        this.accuseVisible=true;
    },
      openEditForm2(oneclass) {
          this.oneclass = oneclass;
          this.editFormVisible = true;
          this.viewFormVisible = false;
          this.accuseVisible=false;
      },
      openCloudspeakerForm(oneclass) {
          this.oneclass = oneclass;
          this.cloudspeakerFormVisible = true;
      },
      openPrintingForm(oneclass) {
          this.oneclass = oneclass;
          this.printingFormVisible = true;
      },
    add() {
      this.oneclass = {};
      this.editFormVisible = true;
    },
    batchDel() {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
          oneclassService
          .delUsers({
            ids: JSON.stringify(this.multipleSelection.map(s => s.id))
          })
          .then(() => {
            this.getTableData();
          });
      });
    },
    del(id) {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
          oneclassService.delOneclass({id:id}).then(() => {
          this.getTableData();
        });
      });
    }
  }
};
</script>
